import { RedeemChallengeAction, RedeemChallengeRequest, RedeemChallengeResult } from './redeem-challenge';
import { sameOriginRequestPolicy } from '../actions';
import { HTTP_STATUS_OK } from '../../../helpers/validation/common';
import { parseChallengeFailure } from '../challenge-failure';

export class RemoteRedeemPowChallengeAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: RedeemChallengeAction = async (request: RedeemChallengeRequest): Promise<RedeemChallengeResult> => {
		const base: string = this.baseUrl || '';
		const response: Response = await fetch(
			`${base}/api/challenge/redeem`,
			{
				...sameOriginRequestPolicy,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(request)
			}
		);
		if (response.status === HTTP_STATUS_OK) {
			return;
		}

		return parseChallengeFailure(response, 'Failed to redeem challenge');
	};
}
